/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type AddressLevel = typeof AddressLevel[keyof typeof AddressLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddressLevel = {
  Individual: 'Individual',
  Cluster: 'Cluster',
} as const;
